import * as React from "react";
import Button from "../../Button";
import { DeleteIcon } from "../../icons";
import "./index.css";
import Visa from "../../../images/visa.png";
import ConfirmDialog from "../../Dialogs/ConfirmDialog";

const PaymentMethodTile = ({ onDelete, onSetDefault, pm, isDefault }) => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  const onDeleteConfirm =async () => {
    await onDelete(pm);
    setShowConfirm(false)
  }
  const onClose = () => {
    setShowConfirm(false);
  }
  return (
    <div className={"payment-method-tile-base" + (isDefault ? " active" : "")}>
      <div className="card-logo">
        <img
          src={`https://raw.githubusercontent.com/datatrans/payment-logos/master/assets/cards/${pm.card.display_brand
            .toLowerCase()
            .replaceAll("_", "-")}.svg`}
          alt={pm.card.brand}
        />
      </div>
      <div className="payment-method-details">
        <div className="payment-method-tile-title">
          <span>Visa ending in&nbsp;{pm.card.last4}</span>
        </div>
      </div>
      {!isDefault ? (
        <button onClick={onSetDefault} className={"payment-method-tile-delete"}>
          Set as Default
        </button>
      ) : (
        <span
          className="payment-method-tile-delete"
          style={{
            opacity: 0.5,
          }}
        >
          Default Card
        </span>
      )}
      {!isDefault && (
        <button onClick={() => setShowConfirm(!showConfirm)} className={"payment-method-tile-delete"}>
          <DeleteIcon
            className={"payment-method-tile-delete-icon"}
            fill="rgba(0, 0, 0, 0)"
          />
          Delete
        </button>
      )}
       {
                        showConfirm ? <ConfirmDialog title={"Delete Card"} subtitle={"Are you sure you want to delete this Card"} onConfirm={() => onDeleteConfirm()} onClose={onClose}/> : <></>
                      }
    </div>
    
  );
};

export default PaymentMethodTile;
